const {FLAGS} = require("./GlobalFlags");

const DEV_TESTING_SHORTCUT_EVENT = "devTestingShortcutActivated";
let isSetup = false;
let keyQueue: string[] = [];

const onKeyDown = (event: KeyboardEvent) => {
	// Listen for Ctrl+Alt+Cmd+0 and Ctrl+Alt+Shift+0
	if (
		event.key === "0" &&
		event.ctrlKey &&
		(event.metaKey || event.shiftKey) &&
		event.altKey
	) {
		event.preventDefault();
		event.stopPropagation();
		window.dispatchEvent(new Event(DEV_TESTING_SHORTCUT_EVENT));
	} else {
		// Listen for "test"
		keyQueue.push(event.key);
		if (keyQueue.length > 4) {
			keyQueue.shift();
		}
		if (keyQueue.join("") === "test") {
			window.dispatchEvent(new Event(DEV_TESTING_SHORTCUT_EVENT));
			keyQueue = [];
		}
	}
};

/**
 * Set up the shortcuts for checkout forms in development.
 *
 * @returns function to teardown the shortcuts
 */
const setupDevTestingShortcut = () => {
	if (!FLAGS.enableDevTestingShortcut || isSetup) {
		return;
	}
	isSetup = true;
	window.addEventListener("keydown", onKeyDown);
	return teardownDevTestingShortcut;
};

const teardownDevTestingShortcut = () => {
	isSetup = false;
	window.removeEventListener("keydown", onKeyDown);
};

const addDevTestingShortcutHandler = (handler: () => void) => {
	window.addEventListener(DEV_TESTING_SHORTCUT_EVENT, handler);
	return () => {
		window.removeEventListener(DEV_TESTING_SHORTCUT_EVENT, handler);
	};
};

module.exports = {
	setupDevTestingShortcut,
	teardownDevTestingShortcut,
	addDevTestingShortcutHandler,
};
